/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedProductVariantRequestDto } from '../../models/backend-patched-product-variant-request-dto';
import { BackendProductVariantDto } from '../../models/backend-product-variant-dto';

export interface SalesProductVariantsPartialUpdate$Params {
  /**
   * A unique integer value identifying this product variant.
   */
  id: number;
  body?: BackendPatchedProductVariantRequestDto;
}

export function salesProductVariantsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: SalesProductVariantsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductVariantDto>> {
  const rb = new RequestBuilder(rootUrl, salesProductVariantsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductVariantDto>;
    }),
  );
}

salesProductVariantsPartialUpdate.PATH = '/api/sales/product_variants/{id}/';
